class FiberCompanySalesOrgReq {
    constructor() {
        this.fiberCompanyId = null;
        this.salesOrgIds = null;
    }
}
export default FiberCompanySalesOrgReq;